export function addToRecent(aiId: string, title: string) {
    const csrfTokenInAi = ($ as any).ajaxSetup()['data'].YII_CSRF_TOKEN;

    if (aiId === "-1") {
        return;
    }

    if (typeof updateRecentItemsTopMenu !== 'undefined') {
        updateRecentItemsTopMenu(aiId, 'recent_activity', title);
    }

    $.ajax({
        url: wbConfig.baseUrl + '/pmActionItem/AddActionItemToRecent',
        contentType: 'application/json; charset=utf-8',
        dataType: "json",
        type: 'POST',
        data: JSON.stringify({actionItemId: parseInt(aiId)}),
        headers: {
            YII_CSRF_TOKEN: csrfTokenInAi,
            "yii-csrf-token": csrfTokenInAi
        }
    });
}